import React from 'react'
import './index.less'
import { Button, Tabs, } from 'antd'
import PurchaseTable from 'CMPT/vehicleMonitoring/servicePurchase/purchaseTable'
import UseTable from 'CMPT/vehicleMonitoring/servicePurchase/useTable'
import { API } from "@/http/api";
import http from "@/http";
const { TabPane } = Tabs

const overviewMap = [
  {
    key: 'balanceNumber',
    title: '剩余次数',
  },
  {
    key: 'todayUsedNumber',
    title: '今日使用次数',
  },
  {
    key: 'usedNumber',
    title: '累计使用次数',
  },
  {
    key: 'totalAmount',
    title: '累计购买金额/元',
  },
  {
    key: 'totalNumber',
    title: '累计购买次数',
  },
]
class IndexPage extends React.Component {
  state = {
    // 选中tabs
    activeKey: '1',
    identity: '',
    servicePurchase: []
  }

  changeTabs = (key) => {
    this.setState({
      activeKey: key
    })
  }
  componentDidMount() {
    this.init();
  }
  init = () => {
    const config = {
      api: API.trackQueryStatistics,
    };
    http(config).then((res) => {
      if (res.code == 200) {
        if (res.result != null) {
          this.setState({
            servicePurchase: res.result
          })
        } else {
          this.setState({
            servicePurchase: {
              "totalAmount": 0,
              "totalNumber": 0,
              "balanceNumber": 0,
              "usedNumber": 0,
              "todayUsedNumber": 0,
            }
          })
        }

      }
    });
  }
  goSubCharge = () => {
    this.props.history.push('/app/crm/servicePurchase/purchase')
  }
  render() {
    const { activeKey, servicePurchase } = this.state;
    return (
      <div className='service_purchase' >
        <div className='overview'>
          <div className='overview_count'>
            {overviewMap.map((item, index) => {
              return (
                <div className='overview_count_item' key={item.key}>
                  <p className='count'>{servicePurchase[`${item.key}`] || 0}</p>
                  <p className='title'>{item.title}</p>
                </div>
              )
            })}
          </div>
          <div>
            <Button type='primary'  onClick={this.goSubCharge}>购买</Button>
          </div>
        </div>
        <div className='count_tables'>
          <Tabs
            activeKey={activeKey}
            onChange={this.changeTabs}
            tabBarStyle={{
              paddingLeft: '24px',
            }}
          >
            <TabPane tab="充值记录" key="1" className='tab1'>
              <PurchaseTable />
            </TabPane>
            <TabPane tab="消费记录" key="2" className='tab1'>
              <UseTable />
            </TabPane>
          </Tabs>

        </div>
      </div>
    )
  }
}

export default IndexPage
